<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { PageHeader, NextButton },
  data() {
    return { inboxName: '', apiKey: '', sender: '' };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  methods: {
    async createChannel() {
      if (!this.inboxName.trim() || !this.apiKey || !this.sender) {
        useAlert('Заполните название, API-ключ и номер отправителя Exolve');
        return;
      }
      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName.trim(),
          channel: {
            type: 'exolve',
            phone_number: this.sender,
            provider_config: { api_key: this.apiKey, sender: this.sender },
          },
        });
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: inbox.id },
        });
      } catch (error) {
        useAlert(error?.response?.data?.message || 'Не удалось создать источник Exolve');
      }
    },
  },
};
</script>

<template>
  <div class="w-full h-full col-span-6 p-6">
    <PageHeader
      header-title="Exolve (МТС)"
      header-content="Источник для отправки СМС через облачную платформу МТС Exolve."
    />
    <form class="flex flex-col flex-wrap mx-0" @submit.prevent="createChannel">
      <div class="flex-shrink-0 flex-grow-0">
        <label>Название инбокса<input v-model="inboxName" type="text" placeholder="Например: Exolve СМС" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>API-ключ Exolve (JWT)<input v-model="apiKey" type="text" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>Номер отправителя<input v-model="sender" type="text" placeholder="79500370873" /></label>
      </div>
      <div class="w-full mt-4">
        <NextButton :is-loading="uiFlags.isCreating" type="submit" solid blue label="Создать источник" />
      </div>
    </form>
  </div>
</template>
